<template>

  <div>

  </div>

</template>

<script>
import {mapState} from 'vuex'
import {CognitoAuth} from 'amazon-cognito-auth-js';
import api from "../services/groupsPlaceApi";

import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbSpinner,
  mdbView
} from 'mdbvue';
import store from "../store";
import axios from 'axios';

export default {
  name: 'Login',
  components: {
    mdbInput,
    mdbBtn,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbSpinner,
    mdbMask,
    mdbView,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter
  },
  computed: mapState({
                       apiKey: state => state.apiKey,
                       userDetails: state => state.userDetails,
                       loggedIn: state => state.loggedIn,
                       settings: state => state.settings
                     }),
  data() {
    return {}
  },
  watch: {
    settings(n, o) {
      if (n.topLogo) this.topLogo = n.topLogo;
      if (!o || !o.identityProvider) {
        if (n.identityProvider == "COGNITO") {
          console.log("Settings loaded with IDP")
          this.cognitoLogin()
        }
      }
    }
  },
  mounted() {
    console.log("Started...")
    if (this.settings.identityProvider == "COGNITO") {
      this.cognitoLogin()
    }
    document.title = "Login"

    if (this.loggedIn) this.$router.push("/")
    if (this.$route.query.msg) this.error = this.$route.query.msg

    let el = document.getElementById("user-name")
    if (el) el.focus()
  },
  methods: {
    cognitoLogin() {
      let auth = new CognitoAuth(this.settings.cognitoAuthData);
      console.log("Auth ", auth);
      auth.userhandler = {
        onSuccess: (result) => {
          store.dispatch("setCognitoAuth", auth)
          let affiliateCode = window.localStorage.getItem("affiliate")
          axios.post(process.env.BACKEND_URL + "/api/v1/user/cognitoLogin",
                     {token: auth.getSignInUserSession().getIdToken().jwtToken, affiliateCode: affiliateCode},
                     {withCredentials: true}).then(
            (details) => {
              let key = details.data.authKey
              let secret = details.data.secret
              let isNewUser = details.data.isNewUser
              if (key) {
                api.completeLogin(key, secret, isNewUser)
                window.localStorage.removeItem("affiliate")
              } else this.error = "Invalid response from server."
            },
            (error) => {
              this.$notify.error({message: error.response.data, timeOut: 4000})
            })
        },
        onFailure: (err) =>  {
          this.$store.commit("loggedIn", false)
          this.$notify.error({message: err, timeOut: 30000})
        }
      };
      auth.parseCognitoWebResponse(window.location.href);


    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 749px ) {
  .login-form {
    margin: auto;
    width: 80%;

  }
}

@media screen and (min-width: 750px ) {
  .login-form {
    margin: auto;
    width: 50%;
  }
}

.gradient {
  background: -moz-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: -webkit-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: -webkit-gradient(linear, 45deg, from(rgba(42, 27, 161, 0.7)), to(rgba(29, 210, 177, 0.7)));
  background: -o-linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  background: linear-gradient(45deg, rgba(42, 27, 161, 0.7), rgba(29, 210, 177, 0.7) 100%);
  height: calc(100vh);
}

.full-view {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  height: calc(100vh);
}

.logo-top {
  max-width: 60%;
  margin: auto;
}

</style>
